import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

const BaseItemSchema = z.object({
  name: z.string(),
  level: z.string(),
  mediaDataId: z.string(),
  activityId: z.string().optional(),
});

export type SidebarItem = z.infer<typeof BaseItemSchema> & {
  subItems: SidebarItem[];
};

const item: z.ZodType<SidebarItem> = BaseItemSchema.extend({
  subItems: z.lazy(() => item.array().prefault([])) as z.ZodType<SidebarItem[]>,
});

export const SidebarTreeSchema = createResponseSchema(item);

export type SidebarTree = z.infer<typeof SidebarTreeSchema>;
